import get from 'lodash/get';
import sortBy from 'lodash/sortBy';
import { getMetricOvbDisplayName } from '@utils/metrics';
import { metricKeys } from '@pulse/metrics';
import { BM_SUPPORTED_DIMENSIONS, BM_SUPPORTED_ADVANCED_DIMENSIONS } from '@src/utils/kpi';
import { ALL_TRAFFIC } from '@src/utils/constants';

export const getFilterInfo = (appliedFilter: any) => {
  const filterRules = get(appliedFilter, 'rule', []);
  const hasCountryInFilter = filterRules.some((ruleGroup: any[]) =>
    ruleGroup.some((rule: any) => rule.field === 'GEO_COUNTRY'),
  );
  const filterName = get(appliedFilter, 'name', ALL_TRAFFIC);

  return {
    hasCountryInFilter,
    filterName,
  };
};

export const getBenchmarkSupportedDimensions = (
  benchmarkFlag: boolean,
  advancedBenchmarkFlag: boolean,
  allDimensions: any[],
) => {
  if (!benchmarkFlag) {
    return [];
  }

  const supportedDimensionKeys = advancedBenchmarkFlag
    ? [...BM_SUPPORTED_DIMENSIONS, ...BM_SUPPORTED_ADVANCED_DIMENSIONS]
    : BM_SUPPORTED_DIMENSIONS;

  const options: any[] = [];
  supportedDimensionKeys.forEach((dimensionKey) => {
    const dimension = allDimensions.find((d) => d.groupBy === dimensionKey);
    if (dimension) {
      options.push({
        value: dimension.groupBy,
        label: dimension.name,
      });
    }
  });

  return sortBy(options, 'label');
};

export const getKpiMetricList = (
  kpiMetrics: any[],
  showImpactedDevices: boolean,
  isIntervalGreaterThanADay: boolean,
  benchmarkSupportedMetrics: string[],
) => {
  const options: any[] = [];
  kpiMetrics.forEach((metricKey) => {
    if (
      metricKey === metricKeys.BadUniqueDevices &&
      (!showImpactedDevices || isIntervalGreaterThanADay)
    ) {
      return;
    }

    if (!benchmarkSupportedMetrics.includes(metricKey)) {
      return;
    }

    const ovbDisplayName = getMetricOvbDisplayName({ metricKey });
    options.push({
      value: metricKey,
      label: ovbDisplayName,
    });
  });

  return sortBy(options, 'label');
};

export const getBenchmarkSupportedMetrics = (supportedMetricsStore: any) => {
  return get(supportedMetricsStore, ['response', 'data', 'data'], []);
};

export const getInitialDimensions = (allDimensionValues: string[], maxCount: number = 3) => {
  const defaultDimensions = ['c3.video.isLive', 'GEO_COUNTRY', 'm3.dv.n'];

  const selectedDimensions = defaultDimensions.filter((dim) => allDimensionValues.includes(dim));

  // If we don't have enough default dimensions, fill with remaining available dimensions
  if (selectedDimensions.length < maxCount) {
    const remainingDimensions = allDimensionValues.filter(
      (dim) => !selectedDimensions.includes(dim),
    );
    selectedDimensions.push(...remainingDimensions.slice(0, maxCount - selectedDimensions.length));
  }

  return selectedDimensions.slice(0, maxCount);
};
